import React from 'react';

/**
 * Icône Cybersécurité - Bouclier avec cadenas
 */
const Cybersecurity = ({
  size = 48,
  className = '',
  animate = false
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-security ${animate ? 'icon-animate' : ''} ${className}`}
    >
      <defs>
        <linearGradient id="securityGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#059669" />
          <stop offset="100%" stopColor="#10b981" />
        </linearGradient>
      </defs>

      {/* Bouclier */}
      <path
        d="M24 10 L32 14 L32 22 Q32 30 24 36 Q16 30 16 22 L16 14 Z"
        stroke="url(#securityGrad)"
        strokeWidth="2.5"
        fill="url(#securityGrad)"
        fillOpacity="0.15"
      />

      {/* Cadenas */}
      <g transform="translate(24, 20)">
        {/* Anse du cadenas */}
        <path
          d="M-3 0 Q-3 -4 0 -4 Q3 -4 3 0"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        {/* Corps du cadenas */}
        <rect
          x="-4"
          y="0"
          width="8"
          height="6"
          rx="1"
          fill="white"
        />
        {/* Trou de serrure */}
        <circle cx="0" cy="3" r="1" fill="#059669" />
        <line x1="0" y1="4" x2="0" y2="5" stroke="#059669" strokeWidth="1" strokeLinecap="round" />
      </g>

      {/* Symbole checkmark */}
      <g opacity="0.8">
        <path
          d="M20 24 L22 26 L28 20"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default Cybersecurity;
